import { useEffect } from "react";
import { useUser } from "@clerk/clerk-react";
import {
  trackSignup,
  trackDashboardAccess,
  identifyUser,
} from "../lib/analytics";

export default function AnalyticsTracker() {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    if (!isLoaded || !user) return;

    // Identify the user for B2B tracking
    identifyUser({
      id: user.id,
      email: user.primaryEmailAddress?.emailAddress,
      firstName: user.firstName || undefined,
      lastName: user.lastName || undefined,
      createdAt: user.createdAt
        ? new Date(user.createdAt).toISOString()
        : undefined,
    });

    // Check if this is a new user (created within the last minute)
    const isNewUser =
      user.createdAt && Date.now() - new Date(user.createdAt).getTime() < 60000;

    if (isNewUser) {
      // Determine signup method from external accounts
      const githubAccount = user.externalAccounts?.find(
        (account) => account.provider === "github",
      );
      const googleAccount = user.externalAccounts?.find(
        (account) => account.provider === "google",
      );

      const signupMethod = githubAccount
        ? "github"
        : googleAccount
          ? "google"
          : "github";

      // Track signup conversion
      trackSignup(signupMethod, true);
    }

    // Track dashboard access
    trackDashboardAccess();
  }, [user, isLoaded]);

  return null;
}
